import SceButton from  "../../../../../Common/CommonComponents/sceButton";
import {getLocalizedStringstwo} from'../../twoFactorAuthenticationStrings';
import classes from '../../TwoFactorAuth.scss';

function PhoneStepOne(props) {
  let strings = getLocalizedStringstwo('TwoFactorAuthentication');

  return (
    <div className={classes.card}>
    <div className={classes.btnsPadding}>
         <div className={classes.contentContainer}> 
         <div className={["sce-center-alg", "sce-content-row", classes.verifyLogIn].join(" ")}> {strings.VerifyYourPhoneAddress}
           <div className={["sce-content-row", classes.verifyAddress].join(" ")}>  {props.maskedValue} </div>
         </div>
         <div className={["sce-content-row", classes.subText].join(" ")}>{props.isCall?strings.verifyVoiceNumber:strings.verifyTextNumber} </div>
         <div className={["sce-content-row", "row", classes.btnsPadding].join(" ")}>
                
             <div className={['sce-center-alg',"sce-content-row"].join(" ")}>
                 <SceButton type='button' value={strings.sendCode} id='sms' name='sms' onClick={props.sendCodeHandler}  isDisabled={(props.disableSendCodeBtn) ? true : false} 
                           buttonType={(props.disableSendCodeBtn) ?'sceBtnDisabledPrimary' : 'primary'} /> 
             </div>   
           </div>
         </div>

    </div>
    </div>
  );
}

export default PhoneStepOne;
